import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const TZ_OPTIONS = ['Asia/Riyadh', 'Asia/Bahrain', 'Asia/Dubai', 'Asia/Kuwait', 'Asia/Qatar', 'Asia/Muscat', 'Africa/Cairo',
  'Asia/Karachi', 'Asia/Kolkata', 'Asia/Dhaka', 'Europe/London', 'America/New_York', 'America/Chicago', 'America/Denver',
  'America/Los_Angeles', 'Australia/Sydney'];
const ZATCA = [
  ['cr_number', 'Branch CR (blank = company CR)', '1010xxxxxx'],
  ['zatca_street', 'Street', 'Prince Naif Street'],
  ['zatca_building_number', 'Building no. (4 digits)', '2667'],
  ['zatca_district', 'District', 'King Fahd District'],
  ['zatca_city', 'City', 'Riyadh'],
  ['zatca_postal_code', 'Postal code (5 digits)', '12271'],
];

export const BRANCH_EXTRA_KEYS = ['timezone', ...ZATCA.map(([k]) => k)];

// Optional timezone override + ZATCA seller overrides on the existing Edit Branch form.
export const BranchZatcaFields = ({ formData, setFormData }) => {
  const set = (k, v) => setFormData((f) => ({ ...f, [k]: v }));
  return (
    <details className="rounded-lg border border-border p-3" data-testid="branch-zatca-section">
      <summary className="text-sm font-medium cursor-pointer">Timezone & ZATCA details (optional)</summary>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div className="col-span-2">
          <Label className="text-xs">Timezone override (blank = automatic from location/country)</Label>
          <Input list="branch-tz-options" value={formData.timezone || ''} onChange={(e) => set('timezone', e.target.value)}
            placeholder="Automatic" data-testid="branch-timezone-input" />
          <datalist id="branch-tz-options">{TZ_OPTIONS.map((z) => <option key={z} value={z} />)}</datalist>
        </div>
        <p className="col-span-2 text-[11px] text-muted-foreground">ZATCA fields: leave blank to use the Company Profile.</p>
        {ZATCA.map(([k, label, ph]) => (
          <div key={k}>
            <Label className="text-xs">{label}</Label>
            <Input value={formData[k] || ''} onChange={(e) => set(k, e.target.value)} placeholder={ph} data-testid={`branch-${k}-input`} />
          </div>
        ))}
      </div>
    </details>
  );
};
